export default __webpack_public_path__ + "static/media/ticket_average.9b7f2c4c.svg";